// zh translations for the buyer payment portal. Generated to mirror
// en.ts keys 1:1; ICU placeholders ({seller}, {qty}, …) preserved verbatim.
// Brand names and financial acronyms (Caratuva, ACH, SEPA, IBAN,
// SWIFT, PIX, CNPJ, CPF, KYC, …) intentionally kept untranslated.
const zh: Record<string, string> = {
  'app.name': 'Caratuva',
  'locale.label': '语言',
  'invoice.title': '来自 {seller} 的发票',
  'invoice.amount.label': '应付金额',
  'invoice.lineItems.heading': '明细项',
  'invoice.lineItem.qty': '数量 {qty} × {unitPrice}',
  'invoice.cta.signin': '登录以付款',
  'invoice.cta.continue': '继续付款',
  'invoice.dueDate': '到期日 {date}',
  'invoice.status.label': '状态',
  'invoice.error.notFound': '未找到发票。',
  'signin.heading': '登录以付款',
  'signin.subheading': '我们将向您发送一个一次性链接，无需密码。',
  'signin.email.label': '电子邮箱',
  'signin.email.placeholder': 'you@company.com',
  'signin.submit': '发送登录链接',
  'signin.tos': '继续即表示您同意我们的<terms>服务条款</terms>和<privacy>隐私政策</privacy>。',
  'signin.success.heading': '请查收您的电子邮件',
  'signin.success.body': '我们已发送登录链接，将在 15 分钟后过期。',
  'signin.error.emailMismatch': '该电子邮箱与发票收件人不匹配。',
  'signin.error.generic': '无法发送登录链接，请稍后重试。',
  'signin.session.expired': '您的会话已过期，请重新登录。',
  'consume.loading': '正在为您登录…',
  'consume.error.invalid': '此登录链接无效。',
  'consume.error.used': '此登录链接已被使用，请重新申请一个。',
  'consume.error.expired': '此登录链接已过期，请重新申请一个。',
  'consume.error.generic': '无法为您登录，请重新申请登录链接。',
  'consume.cta.requestNew': '申请新链接',
  'kyc.heading': '验证您的身份',
  'kyc.subheading': '完成一次性身份核验，以便我们为此发票开通入金 (on-ramp)。',
  'kyc.step.entityType': '账户类型',
  'kyc.step.tos': '服务条款',
  'kyc.step.personal': '个人信息',
  'kyc.step.address': '地址',
  'kyc.step.documents': '身份证件',
  'kyc.step.business': '企业信息',
  'kyc.step.businessAddress': '企业地址',
  'kyc.step.owners': '受益所有人',
  'kyc.step.businessDocuments': '企业文件',
  'kyc.step.review': '审核',
  'kyc.step.indicator': '第 {current} 步，共 {total} 步',
  'kyc.entityType.heading': '您是以个人身份还是代表企业完成此流程？',
  'kyc.entityType.body':
    '请选择与付款方相符的选项。企业需提供公司文件和受益所有人信息；个人只需提供本人身份证件。',
  'kyc.entityType.individual': '个人',
  'kyc.entityType.individual.body': '您以私人身份付款，而非代表公司。',
  'kyc.entityType.business': '企业',
  'kyc.entityType.business.body': '您代表已注册的公司或其他法律实体付款。',
  'kyc.field.legalName.label': '公司法定名称',
  'kyc.field.legalName.placeholder': 'Caratuva Inc.',
  'kyc.field.formationDate.label': '成立日期',
  'kyc.field.website.label': '公司网站',
  'kyc.field.website.placeholder': 'https://example.com',
  'kyc.field.businessTaxId.label': '企业税号',
  'kyc.field.businessTaxId.placeholder': '12-3456789 / 12.345.678/0001-95',
  'kyc.field.businessTaxId.hint': 'EIN（美国）、CNPJ（巴西）或当地等效税号。',
  'kyc.field.incorporationDocFile.label': '公司注册文件',
  'kyc.field.incorporationDocFile.hint': '公司章程、设立证书或等效文件。',
  'kyc.field.proofOfOwnershipDocFile.label': '所有权证明',
  'kyc.field.proofOfOwnershipDocFile.hint':
    '股权结构表、所有权登记册或可显示所列受益所有人的等效文件。',
  'kyc.owners.heading': '受益所有人',
  'kyc.owners.body':
    '请添加持有公司 25% 或以上股份，或行使重大控制权的任何人。每位所有人都需要完成与个人买方相同的身份核验。',
  'kyc.owners.add': '添加其他所有人',
  'kyc.owners.remove': '移除',
  'kyc.owners.title': '所有人 {index}',
  'kyc.owners.role.label': '角色',
  'kyc.owners.role.placeholder': '选择角色',
  'kyc.owners.role.beneficial_controlling': '受益所有人兼控制人',
  'kyc.owners.role.beneficial_owner': '受益所有人',
  'kyc.owners.role.controlling_person': '控制人',
  'kyc.owners.taxType.label': '税号类型（仅限美国）',
  'kyc.owners.taxType.placeholder': '选择税号类型',
  'kyc.owners.taxType.SSN': 'SSN',
  'kyc.owners.taxType.ITIN': 'ITIN',
  'kyc.owners.proofOfAddress.label': '地址证明',
  'kyc.owners.proofOfAddress.hint': '显示所有人居住地址的文件（近 90 天内出具）。',
  'kyc.owners.proofOfAddressType.label': '地址证明类型',
  'kyc.owners.proofOfAddressType.placeholder': '选择证明类型',
  'kyc.owners.proofOfAddressType.UTILITY_BILL': '水电费账单',
  'kyc.owners.proofOfAddressType.BANK_STATEMENT': '银行对账单',
  'kyc.owners.proofOfAddressType.RENTAL_AGREEMENT': '租赁合同',
  'kyc.owners.proofOfAddressType.TAX_DOCUMENT': '税务文件',
  'kyc.owners.proofOfAddressType.GOVERNMENT_CORRESPONDENCE': '政府函件',
  'kyc.tos.heading': '接受结算合作伙伴的服务条款',
  'kyc.tos.body':
    '您将被重定向至我们的结算合作伙伴以查看并接受服务条款。接受后，我们会将您带回此处继续。',
  'kyc.tos.cta': '继续前往服务条款',
  'kyc.tos.cta.pending': '正在打开结算合作伙伴…',
  'kyc.tos.accepted': '服务条款已接受。',
  'kyc.tos.required': '请先接受服务条款再继续。',
  'kyc.tos.error': '无法启动服务条款流程。请稍后重试。',
  'kyc.field.email.label': '电子邮箱',
  'kyc.field.firstName.label': '名字',
  'kyc.field.firstName.placeholder': 'Maria',
  'kyc.field.lastName.label': '姓氏',
  'kyc.field.lastName.placeholder': 'Silva',
  'kyc.field.dateOfBirth.label': '出生日期',
  'kyc.field.taxId.label': '税号',
  'kyc.field.taxId.placeholder': '123-45-6789 / 123.456.789-00',
  'kyc.field.taxId.hint': 'SSN/EIN（美国）、CPF（巴西）或当地等效证件。',
  'kyc.field.country.label': '居住国家',
  'kyc.field.country.placeholder': '选择国家',
  'kyc.field.phone.label': '电话（选填）',
  'kyc.field.phone.placeholder': '+1 555 123 4567',
  'kyc.field.addressLine1.label': '地址第 1 行',
  'kyc.field.addressLine1.placeholder': '街道及门牌号',
  'kyc.field.addressLine2.label': '地址第 2 行（选填）',
  'kyc.field.addressLine2.placeholder': '公寓、套间、单元',
  'kyc.field.city.label': '城市',
  'kyc.field.stateProvinceRegion.label': '州 / 省 / 地区',
  'kyc.field.postalCode.label': '邮政编码',
  'kyc.field.idDocCountry.label': '证件签发国',
  'kyc.field.idDocType.label': '证件类型',
  'kyc.field.idDocType.placeholder': '选择证件类型',
  'kyc.field.idDocType.passport': '护照',
  'kyc.field.idDocType.id_card': '居民身份证',
  'kyc.field.idDocType.drivers': '驾驶证',
  'kyc.field.idDocNumber.label': '证件号码（可选）',
  'kyc.field.selfieFile.label': '自拍照',
  'kyc.field.selfieFile.hint':
    '拍摄一张清晰的面部照片——不戴眼镜、不戴帽子、光线充足。JPG 或 PNG，最大 8 MB。',
  'kyc.field.idDocFrontFile.label': '证件 — 正面',
  'kyc.field.idDocFrontFile.hint': '证件正面照片，四个角均清晰可见。JPG 或 PNG，最大 8 MB。',
  'kyc.field.idDocBackFile.label': '证件 — 背面',
  'kyc.field.idDocBackFile.hint': '居民身份证和驾驶证需要提供。JPG 或 PNG，最大 8 MB。',
  'kyc.upload.cta': '选择文件',
  'kyc.upload.replace': '替换',
  'kyc.upload.uploading': '上传中…',
  'kyc.upload.uploaded': '已上传',
  'kyc.upload.error': '上传失败。请尝试其他文件。',
  'kyc.upload.unsupported': '请使用小于 8 MB 的 JPG、PNG 或 WebP 文件。',
  'kyc.upload.preview': '预览',
  'kyc.error.required': '此字段为必填项。',
  'kyc.error.email': '请输入有效的电子邮箱地址。',
  'kyc.error.country': '请使用 ISO-3166-1 alpha-2 代码（例如 US、BR、FR）。',
  'kyc.error.dateOfBirth': '请输入有效的出生日期。',
  'kyc.error.minor': '您必须年满 18 岁。',
  'kyc.error.generic': '无法启动您的身份核验。请稍后重试。',
  'kyc.review.heading': '身份核验已提交',
  'kyc.review.body': '您的身份核验正在审核中。处理完成后，我们将通过电子邮件通知您。',
  'kyc.review.cta': '查看付款状态',
  'kyc.review.summary.heading': '核对您的信息',
  'kyc.review.summary.body':
    '请花点时间确认所有信息无误。一旦提交，您将无法编辑 KYC 提交内容——只能重新发起一次。',
  'kyc.submit': '提交身份核验',
  'kyc.submit.pending': '提交中…',
  'kyc.next': '继续',
  'kyc.back': '返回',
  'kyc.status.label': '状态',
  'kyc.status.verifying': '审核中',
  'kyc.status.approved': '已批准',
  'kyc.status.rejected': '已拒绝',
  'kyc.status.notStarted': '未开始',
  'kyc.hosted.cta': '继续前往身份核验服务方',
  'onramp.heading': '选择您的付款方式',
  'onramp.subheading': '您选择付款方式后，我们会锁定汇率报价 10 分钟。',
  'onramp.method.ach': 'ACH（美国银行转账）',
  'onramp.method.wire': '电汇',
  'onramp.method.sepa': 'SEPA（欧盟银行转账）',
  'onramp.method.card': '银行卡',
  'onramp.method.label': '付款方式',
  'onramp.targetCurrency.label': '您将发送的币种',
  'onramp.targetCurrency.helper': '资金到账时，我们按锁定汇率换算。请使其与您付款的账户一致。',
  'onramp.quote.locked': '报价已锁定，{expires} 过期。',
  'onramp.quote.expired': '报价已过期。请刷新以锁定新的报价。',
  'onramp.quote.refresh': '刷新报价',
  'onramp.cta.lockQuote': '锁定汇率报价',
  'onramp.cta.confirm': '确认并获取付款指引',
  'onramp.cta.confirm.pending': '提交中…',
  'onramp.error.generic': '无法发起入金 (on-ramp)。请稍后重试。',
  'onramp.instructions.heading': '发送您的付款',
  'onramp.instructions.subheading':
    '此账户为您的发票专属——请发送准确金额，我们会自动匹配您的转账。',
  'onramp.instructions.bank': '银行',
  'onramp.instructions.accountName': '账户名称',
  'onramp.instructions.accountNumber': '账号',
  'onramp.instructions.routing': 'Routing number',
  'onramp.instructions.iban': 'IBAN',
  'onramp.instructions.swift': 'SWIFT / BIC',
  'onramp.instructions.reference': '参考代码',
  'onramp.instructions.memo': '备注',
  'onramp.instructions.copy': '复制',
  'onramp.instructions.copied': '已复制',
  'onramp.instructions.continue': '跟踪此付款',
  'onramp.instructions.empty': '暂未返回银行转账指引。准备就绪后，我们会通过电子邮件发送给您。',
  'tracking.heading': '付款跟踪',
  'tracking.placeholder': 'KYC、付款方式和入金 (on-ramp) 页面将在后续 PR 中实现。',
  'tracking.cta.back': '返回发票',
  'tracking.cta.startOnRamp': '继续付款',
  'tracking.refreshing': '正在轮询更新…',
  'tracking.timeline.heading': '进度',
  'tracking.step.invoice': '已收到发票',
  'tracking.step.kyc': '身份核验已完成',
  'tracking.step.onramp': '已发起入金 (on-ramp)',
  'tracking.step.fiat': '已收到资金',
  'tracking.step.offramp': '已发起出金 (off-ramp)',
  'tracking.step.settled': '已以 BRL 结算',
  'tracking.alert.kycRejected.heading': '身份核验已拒绝',
  'tracking.alert.kycRejected.body': '您的身份核验未能通过。请使用更新后的信息重新提交。',
  'tracking.alert.kycRejected.cta': '重新提交身份核验',
  'tracking.alert.kycPending.heading': '身份核验审核中',
  'tracking.alert.kycPending.body':
    '我们正在等待验证服务商的结果。完成后我们将通过电子邮件通知您。',
  'tracking.alert.underpayment.heading': '检测到付款不足',
  'tracking.alert.underpayment.body': '我们收到的金额少于发票金额。请联系支持以进行核对。',
  'tracking.alert.contactSupport': '联系支持',
  'tracking.alert.expired.heading': '发票已过期',
  'tracking.alert.expired.body': '此发票已过期。请联系卖方重新开具一份。',
  'tracking.alert.cancelled.heading': '发票已取消',
  'tracking.alert.cancelled.body': '卖方已取消此发票。',
  'common.loading': '加载中…',
  'common.retry': '重试',
};
export default zh;
